import Focus from '../../../shared/types/enums/focus';
import Rail from '../../../shared/classes/rail';
import TMain from '../templates/main';
import lastShowsChannelObservable from '../../../shared/api/lastShowsChannel/observable';
import useComplete from '../../../shared/components/utils/hooks/useComplete';
import { Observer, Subscription } from 'rxjs';
import { routerSelector } from '../../../shared/store/slices/router.slice';
import { setFocus } from '../../../shared/store/slices/focus.slice';
import { useAppDispatch, useAppSelector } from '../../../shared/store/hooks';
import { useEffect, useState } from 'react';

function LastShowsChannel() {
  const dispatch = useAppDispatch();
  const {
    params: { current: currentParams },
  } = useAppSelector(routerSelector);

  const [complete, setComplete] = useComplete();
  const [rails, setRails] = useState<Rail[]>([]);

  useEffect(() => {
    let subscription: Subscription | null;
    if (!complete) {
      const lastShowsObserver: Observer<{
        data: Rail[];
      }> = {
        next: (val) => {
          setRails(val.data);
        },
        error: () => {
          console.error('Error recovering corners');
        },
        complete: () => {
          setComplete(true);
          dispatch(
            setFocus([
              Focus.RAILS_LIST,
              parseInt(`${Focus.RAILS_SUB_LIST}${0}`),
            ])
          );
          return null;
        },
      };
      if (currentParams?.channelCode) {
        subscription = lastShowsChannelObservable(
          (currentParams as { channelCode: string }).channelCode,
          (currentParams as { channelId: string }).channelId
        ).subscribe(lastShowsObserver as Partial<Observer<unknown>>);
      }
    }
    return () => {
      subscription?.unsubscribe();
    };
  }, [complete]);

  return (
    <TMain
      complete={complete}
      rails={rails}
      sliders={[]}
      startsInMenu={false}
    />
  );
}

export default LastShowsChannel;
